<template>
    <div class="electric-vehicle-soft-search__vehicle-slide">
        <div class="electric-vehicle-soft-search__image-container">
            <img class="electric-vehicle-soft-search__vehicle-image" :src="vehicle.image" alt="" />
        </div>
        <h2 class="electric-vehicle-soft-search__vehicle-title">
            {{ vehicle.model_title }}
        </h2>
        <div class="electric-vehicle-soft-search__vehicle-content">
            <ul class="electric-vehicle-soft-search__spec">
                <div v-if="electricOrHybrid == 'electric' && evRanges.length > 0" class="electric-vehicle-soft-search__spec-point">
                    <p class="electric-vehicle-soft-search__spec-heading">Range:</p>
                    <p v-html="evRangeText"></p>
                </div>
                <div v-else-if="hybridMpgs.length > 0" class="electric-vehicle-soft-search__spec-point">
                    <p class="electric-vehicle-soft-search__spec-heading">MPG:</p>
                    <p v-html="hybridMpgText"></p>
                </div>
                <div v-else class="electric-vehicle-soft-search__spec-point">
                    <p class="electric-vehicle-soft-search__spec-heading">MPG:</p>
                    <p>-</p>
                </div>
                <div class="electric-vehicle-soft-search__spec-point">
                    <p class="electric-vehicle-soft-search__spec-heading">Fuel:</p>
                    <span v-for="fuel_type in vehicle.fuel_types" :key="fuel_type">{{ fuel_type }} </span>
                </div>
                <div v-if="electricOrHybrid == 'electric'" class="electric-vehicle-soft-search__spec-point">
                    <p class="electric-vehicle-soft-search__spec-heading">Average cost per mile:</p>
                    <p>4p</p>
                </div>
                <div class="electric-vehicle-soft-search__spec-point">
                    <p class="electric-vehicle-soft-search__spec-heading">Emissions/CO2:</p>
                    <p v-html="co2CombinedText"></p>
                </div>
                <div class="electric-vehicle-soft-search__spec-point">
                    <p class="electric-vehicle-soft-search__spec-heading">Transmission:</p>
                    <span v-for="transmission in vehicle.transmissions" :key="transmission">{{ transmission }} </span>
                </div>
            </ul>
            <a :href="vehicle.route" class="btn btn-primary electric-vehicle-soft-search__vehicle-button">Discover More</a>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            vehicle: {
                required: true,
            },
            electricOrHybrid: {
                required: true,
            },
            repExample: {
                default: false,
            }
        },
        computed: {
            minEvRange() {
                return parseFloat(this.vehicle.min_ev_range);
            },
            maxEvRange() {
                return parseFloat(this.vehicle.max_ev_range);
            },
            evRanges() {
                let ranges = [];
                if (this.minEvRange > 0) {
                    ranges.push(this.minEvRange);
                }
                if (this.maxEvRange > 0) {
                    ranges.push(this.maxEvRange);
                }
                return ranges;
            },
            evRangeText() {
                return this.evRanges.join(" to ") + " miles";
            },
            minHybridMpg() {
                return parseFloat(this.vehicle.hybrid_mpg_min);
            },
            maxHybridMpg() {
                return parseFloat(this.vehicle.hybrid_mpg_max);
            },
            hybridMpgs() {
                let mpgs = [];
                if (this.minHybridMpg > 0) {
                    mpgs.push(this.minHybridMpg);
                }
                if (this.maxHybridMpg > 0) {
                    mpgs.push(this.maxHybridMpg);
                }
                return mpgs;
            },
            hybridMpgText() {
                return this.hybridMpgs.join(" - ") + " mpg";
            },
            co2CombinedText() {
                if (this.vehicle.co2 !== null) {
                    return Math.round(this.vehicle.co2) + " g/km";
                }
                return "-";
            },
        },
    };
</script>